import React, { useState, Fragment } from 'react';
import EditDetailsCard from './EditDetailsCard';
import ViewDetailsCard from './ViewDetailsCard';

export default function DetailsCard({...props}) {
  const { 
    family,
    setIsSnackbarOpen,
    setSnackbarVariant,
    setSnackbarMessage,
    handleRecordUpdate,
    handleFavorite,
    favorited,
    handleCancel,
    currentUser,
   } = props;
  const [inEditMode, setInEditMode] = useState(false);
  return (
    <Fragment>
      {
        inEditMode ? 
        <EditDetailsCard
          handleCancel={handleCancel}
          setIsSnackbarOpen={setIsSnackbarOpen}
          setSnackbarVariant={setSnackbarVariant}
          setSnackbarMessage={setSnackbarMessage}
          handleRecordUpdate={handleRecordUpdate}
          setInEditMode={setInEditMode}
          family={family}
        /> : 
        <ViewDetailsCard
          setIsSnackbarOpen={setIsSnackbarOpen}
          setSnackbarVariant={setSnackbarVariant}
          setSnackbarMessage={setSnackbarMessage}
          setInEditMode={setInEditMode}
          handleFavorite={handleFavorite}
          family={family} 
          favorited={favorited}
          currentUser={currentUser}
        />
      }
    </Fragment>
  )
}